import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import './aboutus.css';
import { FaEye, FaMapMarkerAlt, FaClock, FaPhone, FaEnvelope, FaMedal } from 'react-icons/fa';




function AboutUs() {







  return (
    <div className="about-container">
      <header className="about-header">
        <div className="logo-icon">
          <FaEye className="main-icon" />
        </div>
        <h1>Community Eye Care</h1>
        <p className="tagline">Since 2010</p>
      </header>

      <section className="about-content">
        <div className="mission-section">
          <div className="mission-card">
            <h2>Our Purpose</h2>
            <p>To provide vision in all eyes through increase awareness. Make available and provide affordable eye care services to all.</p>
          </div>






          <div className="mission-card">
            <h2>Our Approach</h2>
            <p>Make eye care a very integral part of day to day life by making eye care everywhere and for everyone.</p>
          </div>
        </div>




        <div className='two-section-word-container'>
          <h1 className='reach-unreach'>
            <span className='green-text'>REACHING TO</span>
            <span className='yellow-text'>UNREACH</span>
          </h1>
        </div>


            <div className="about-animated-subtext"> 
              <p>
                At Community Eye Care, we believe that vision is a right not a privilege. As of more than 80% people of 
                Sri Lanka never had eye examination one time in their life. Resultantly blindness rate in Sri Lanka is 1.7% in above 40 
                years of age. More than 50% population cannot afford eye care goods and services. Most parts of Sri Lanka even 
                today People has to travel more than 50km to get eye care services.
                So we believe on mantra: 3A: increase Awareness on eye care, make eye care Available, provide eye care services affordable. 
                <br /><br />
                Our volunteer initiatives provide opportunities for individuals to make a difference, 
                while our free eye check-up camps and provision of affordable spectacles ensure that 
                quality eye care is accessible to all. Through compassion, innovation, and community collaboration, 
                we’re opening eyes and doors to a brighter future.
              </p>
            </div>









<div className="about-impact-section">
  <h2 className="about-impact-title">Our Impact</h2>
  <div className="about-impact-grid">
    {[
      { number: "4,000+", label: "Eye Tests Annually" },
      { number: "4,000+", label: "Spectacles Distributed" },
      { number: "25", label: "District Covered" },
      { number: "300+", label: "Volunteers" }
    ].map((stat, index) => (
      <div key={index} className="about-impact-card">
        <div className="about-impact-number">{stat.number}</div>
        <div className="about-impact-label">{stat.label}</div>
      </div>
    ))}
  </div>
</div>



<div className='appreciaation-letter-section'>
  <h2 className="heading-appreciate">Appreciation Letter from</h2>
  <p className='para-appreciate'></p>
  <img src="/appreciation-letter1.png" alt="Appreciation Letter" />
  <img src="/appreciation-letter2.png" alt="Appreciation Letter" />
  <img src="/appreciation-letter3.png" alt="Appreciation Letter" />
  <img src="/appreciation-letter4.jpg" alt="Appreciation Letter" />

</div>




        <div className="info-cards">
          <div className="info-card">
            <div className="icon-box">
              <FaMapMarkerAlt className="info-icon" />
            </div>
            <h3>Our Centers</h3>
            <div className="location">
              <h4>Colombo 08 - Center</h4>
              <p>No: 932, Maradana Rd, Colombo 08</p>
            </div>

            <div className="location">
              <h4>Moratuwa Center</h4>
              <p>No: 23, Uswatta Circular Rd, Moratuwa</p>
            </div>

          </div>

          <div className="info-card">
            <div className="icon-box">
              <FaClock className="info-icon" />
            </div>
            <h3>Operating Hours</h3>
            <p>Monday to Saturday</p>
            <p className="highlight">8:30 am – 5:00 pm</p>
            <p>Sunday: Closed</p>
          </div>

          <div className="info-card">
            <div className="icon-box">
              <FaPhone className="info-icon" />
            </div>
            <h3>Contact Us</h3>
            <p><strong>Phone:</strong></p>
            <p>+94 11 7 700906 <br/> +94 76 136 0946</p>
            <p><strong>Email:</strong></p> 
            <p>ceccmaradana@gmail.com  <br/> ceccmoratuwa@gmail.com</p>
          </div>
        </div>

        <div className="team-section">
          <h2>Our Expertise</h2>
          <div className="team-card">
            <div className="team-image">
              <FaMedal className="team-icon" />
            </div>
            <div className="team-info">
              <h3>Professional Team</h3>
              <p>Our centers are staffed by qualified ophthalmologists, optometrists, and trained technicians committed to delivering world-class eye care services to all community members regardless of their economic status.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="about-footer">
        <p>Need eye care services? Walk in or book an appointment today!</p>
      <Link to="/bookaneyetest"><button className="cta-button">Book an Eye Test</button></Link> 
      </footer>
    </div>
  );
}

export default AboutUs;